export const user = {
	type: 'object',
	required: [
		'name',
		'surname',
		'gender',
		'personalCode',
		'email',
		'phoneNumber',
		'role',
		'status'
	],
	properties: {
		name: {
			type: 'string',
			minLength: 2,
			maxLength: 255
		},
		surname: {
			type: 'string',
			minLength: 1,
			maxLength: 255
		},
		gender: {
			type: 'string',
			enum: ['male', 'female', 'other']
		},
		personalCode: {
			type: 'string',
			minLength: 1,
			maxLength: 255
		},
		email: {
			type: 'string',
			format: 'email',
			minLength: 1
		},
		phoneNumber: {
			type: 'string',
			minLength: 1
		},
		role: {
			type: 'string',
			enum: ['admin', 'employee', 'teacher', 'student', 'parent']
		},
		status: {
			type: 'string',
			enum: ['active', 'suspended', 'blocked']
		},
		address: {
			$ref: '/address'
		}
	},
	allOf: [
		{
			if: {
				properties: {
					role: {
						enum: ['teacher']
					}
				}
			},
			then: {
				properties: {
					courses: {
						$ref: '/teacher-courses'
					}
				}
			}
		},
		{
			if: {
				properties: {
					role: {
						enum: ['student']
					}
				}
			},
			then: {
				properties: {
					grades: {
						$ref: '/student-grades'
					}
				}
			}
		}
	],
	errorMessage: {
		properties: {
			name: 'validationUserName',
			surname: 'validationUserSurname'
		},
		required: 'validationFieldRequired'
	}
};
